import {base64ToFile, ImageCroppedEvent} from 'ngx-image-cropper';

export const isImageFile = (file: File | null | undefined): boolean => {
  return !!file?.type && file.type.startsWith('image/');
};

export const createCroppedImageFile = (
  event: ImageCroppedEvent,
  fileName = `${Date.now()}.png`
): File | null => {
  const croppedBlob = event?.blob || (event?.base64 ? base64ToFile(event.base64) : null);
  if (!croppedBlob) {
    return null;
  }

  return new File([croppedBlob], fileName, {
    type: croppedBlob.type || 'image/png'
  });
};

export const getUploadProgress = (loaded = 0, total?: number): number => {
  if (!total || total <= 0) {
    return 0;
  }

  const progress = Math.round((loaded / total) * 100);
  return Math.max(0, Math.min(100, progress));
};
